import Component from '../../../shared/component';

export default class InternshipForm extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$trigger = this.$element.find('.internshipForm-trigger');
    this.$typeSelector = this.$element.find('.internshipTypeSelector');
    this.$formElements = this.$element.find(
      '.form-group:not(.form-group--trigger)'
    );

    this.updateFormState();
    this.bindEvents();
  }

  bindEvents() {
    this.handlePublishChange = this.handlePublishChange.bind(this);

    this.$trigger.on('change.InternshipForm', this.handlePublishChange);
  }

  unbindEvents() {
    this.$trigger.off('change.InternshipForm', this.handlePublishChange);
  }

  handlePublishChange() {
    this.updateFormState();
  }

  updateFormState() {
    if (this.$trigger.prop('checked')) {
      this.$typeSelector.removeClass('internshipTypeSelector--read-only');
      this.$formElements.removeClass('form-group--read-only');
    } else {
      this.$typeSelector.addClass('internshipTypeSelector--read-only');
      this.$formElements.addClass('form-group--read-only');
    }
  }
}
